import invariant from "tiny-invariant";

import ConfigureCardStep from "./components/ConfigureCardStep";
import SelectCardTypeStep from "./components/SelectCardStep";
import Step from "./enum/Step";

const steps = [SelectCardTypeStep, ConfigureCardStep];

invariant(steps.length === Object.values(Step).length / 2); // div by 2 because enums have keys to do back conversion too

export default steps;
